<template>
  <div
      v-if="showLevitate"
      ref="moveDiv"
      :class="{ 'dra-tran': showtran }"
      class="refund_levitate-btn"
      mg-stat-mod="c_hwrecactpop"
      @mousedown="down($event)"
      @mousemove="move($event)"
      @mouseup="end"
      @touchend="end"
      @touchmove="move($event)"
      @touchstart="down($event)"
  >
    <img
        :mg-stat-custom="'label=act&cont=推广活动&direct=web&addr=' + encodeURIComponent(gotoBackgroundLink)"
        :mg-stat-lob="`ad_id=${backgroundId}`"
        :src="backgroundImg"
        mg-stat-click
        @click="gotoLink"
    />
    <a ref="close">
      <img
          :src="closeImg"
          class="delete"
          @click="showLevitate = false"
      />
    </a>
  </div>
</template>
<script>
import Env from 'utils/env';
import closeImg from 'assets/img/levitate-button.png';
import _ from 'lodash';
import MgStat from 'MgStat';

export default {
  props: ['levitate'],
  data() {
    return {
      Env,
      backgroundId: 0,
      backgroundImg: '',
      gotoBackgroundLink: '',
      closeImg,
      showLevitate: false,
      flags: false,
      showtran: false,
      position: { x: 0, y: 0 },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      xPum: '',
      yPum: '',
    };
  },
  watch: {
    levitate: {
      handler(val) {
        if (val) {
          this.getLevitateAd();
        }
      },
    },
  },
  methods: {
    async getLevitateAd() {
      try {
        if (!_.isEmpty(this.levitate) && (Env.isMobile || Env.isMgtvApp)) {
          this.showLevitate = true;
          this.backgroundId = this.levitate[0].adId;
          this.backgroundImg = this.levitate[0].adCode;
          this.gotoBackgroundLink = this.levitate[0].adLink;
          MgStat.send('cv', {
            ad_id: this.levitate[0].adId,
            addr: this.levitate[0].adLink,
          }, {
            mod: 'c_hwrecactpop',
          });
        }
      } catch (error) {
        this.$toast(`获取结果失败:${error.message}`);
      }
    },
    down($event) {
      this.flags = true;
      let touch;
      if ($event.touches) {
        [touch] = $event.touches;
      } else {
        touch = $event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.moveDiv.offsetLeft;
      this.dy = this.$refs.moveDiv.offsetTop;
    },
    move($event) {
      if (this.flags) {
        let touch;
        if ($event.touches) {
          [touch] = $event.touches;
        } else {
          touch = $event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        this.$refs.moveDiv.style.left = `${this.xPum}px`;
        this.$refs.moveDiv.style.top = `${this.yPum}px`;
        // 阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        document.addEventListener(
          'touchmove',
          () => {
            $event.preventDefault();
          },
          false,
        );
      }
    },
    // 鼠标释放时候的吸附
    end() {
      this.flags = false;
      if (this.xPum) {
        this.showtran = true;
        // 图片的位置
        const moveDivLeft = this.$refs.moveDiv.style.left.replace('px', '');
        // 中心轴的位置
        const middleWidth = this.getParentSize() / 2;
        let moveLeft;
        if (Number(moveDivLeft) + 70 < middleWidth + 21.5) {
          moveLeft = 0;
        } else {
          moveLeft = this.getParentSize() - 70 - 10.75;
        }
        this.$refs.moveDiv.style.left = `${moveLeft}px`;
        setTimeout(() => {
          this.showtran = false;
        }, 200);
      }
    },

    getParentSize() {
      const style = window.getComputedStyle(this.$el.parentNode, null);
      return parseInt(style.getPropertyValue('width'), 10);
    },
    gotoLink() {
      if (!this.gotoBackgroundLink) {
        return;
      }
      if (
        this.gotoBackgroundLink.indexOf('/topic') !== -1 ||
          this.gotoBackgroundLink.indexOf('h5.da.mgtv.com') !== -1
      ) {
        window.location.href = this.gotoBackgroundLink;
      } else {
        this.$router.push({
          path: 'iframe',
          query: { link: encodeURIComponent(this.gotoBackgroundLink) },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.refund_levitate-btn {
  position: fixed;
  right: 21.5px;
  bottom: 370px;
  width: 140px;
  height: 140px;
  z-index: 1900;
  display: flex;
  touch-action: none;

  img {
    width: 100%;
    height: 100%;
  }

  .delete {
    z-index: 1901;
    position: absolute;
    top: -21.5px;
    right: -21.5px;
    width: 43px;
    height: 43px;
  }
}

.dra-tran {
  transition: top 0.2s ease-out, left 0.2s ease-out;
}
</style>

